import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import URL from '../../../constants/urls'
import ListItems from '../ListItems'
import MiniHeader from '../MiniHeader'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY } from '../../../constants/globalConstants'
import Loader from '../../../global/Loader'
import { getReceipts } from '../../../redux/actions/ReceiptsAction'
import { addEventLog } from '../../../redux/actions/EventsLog'
import CONSTANTS from '../../../redux/constants'
import { errorMessage } from '../../../constants/errorMessage'
// import CommonHeaderAccount from '../../global/CommonHeaderAccount'

function Receipts(props) {
    const {notify, dispatch, loader} = props
    const navigate = useNavigate()
    const {partner} = useParams()
    const [receiptsData, setReceiptsData] = useState()
    
    useEffect(() => {
        dispatch(getReceipts(1)).then((res) => {
            setReceiptsData(res?.data?.data)
        }).catch((err) => {
            let errObject = { 
                payload: 1,
                error: err,
                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong  
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getReceipts-Receipts.js-23`))
            notify('error', err)
        })
    },[EMPTY_ARRAY])

    const handleAdd = () => {
        navigate(`/${partner}/${URL?.ADD_CARD}`)
    }
    const handleDetails = (item) => {
        localStorage.removeItem('paymentRecipt')
        localStorage.setItem('paymentRecipt', JSON.stringify(item))

        if(item?.is_expired){
            navigate(`/${partner}${URL?.RECEIPT_DETAIL}/${item?.ticket_number}`)
        }else{
            navigate(`/${partner}${URL?.CONFIRMATION}/${item?.ticket_number}`)
        }
        
    }
    
  return (
    <div>
      <MiniHeader title={'RECEIPTS'} isDisplayBack isAddIcon handleAdd={handleAdd}/>
      <span className='text-primary m-2 mt-3 small fw-semibold'>Receipts</span>
        {loader ? <Loader/> :<ListItems data={receiptsData} handleDetails={handleDetails}/>}
    </div>
  )
}
Receipts.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    notify: PropTypes.func,
}

Receipts.defaulProps = {
    dispatch: noop,
    loader: true,
    notify: noop,
}

function mapStateToProps({ ReceiptsReducer }) {
    return {
        loader: ReceiptsReducer?.loader
    }
}
export default connect(mapStateToProps)(Receipts)
